import { bannerList } from '../../api/banner'
import { topicList,topicProductList, homeAddress, bybarcode,navList } from '../../api/home'

// initial state
const state = {
	banners: null,
	hotProducts: null,
	recentlyProducts: null,
	goodProducts: null,
	address: null,
	navList:null,
	topicList: null,
}

// mutations
const mutations = {
	saveHomeBanners(state, items) {
		state.banners = items
	},
	saveHomeProducts(state, data) {
		state.hotProducts = data.hot_products
		state.recentlyProducts = data.recently_products
		state.goodProducts = data.good_products
	},
	saveTopicList(state, data) {
		state.topicList = data
	},
	saveHomeAddress(state, data) {
		state.address = data
	},
	saveNavList(state, data) {
		state.navList = data
	}
}

// actions 
const actions = {
	fetchHomeBanner({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			bannerList(params.name).then(
				response => {
					if (response && response.banners) {
						commit('saveHomeBanners', response.banners)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	},
	fetchTopicList({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			topicList(params.display_area, params.page, params.per_page).then(
				response => {
					if (response && response.topic) {
						commit('saveTopicList', response.topic)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	},
	fetchTopicProductList({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			topicProductList(params.topic_id, params.page, params.per_page).then(
				response => {
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	},
	fetchHomeAddress({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			homeAddress(params.lng, params.lat, params.type ).then(
				response => {
					if (response && response.result) {
						commit('saveHomeAddress', response.result)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	},
	fetchNavList({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			navList().then(
				response => {
					if (response && response.nav) {
						commit('saveNavList', response.nav)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	},
	bybarcode({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			bybarcode(params.barcode, params.type).then(
				response => {
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	}
}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/home.js